import script from "./Wysiwyg.vue?vue&type=script&setup=true&lang=ts"
export * from "./Wysiwyg.vue?vue&type=script&setup=true&lang=ts"

import "./Wysiwyg.vue?vue&type=style&index=0&id=f356c174&lang=css"

const __exports__ = script;

export default __exports__
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QEditor,QBtn});
